/**
 * Platform assistant chatbot embed configuration.
 * Used for the in-app help assistant that guides users through the platform.
 */
export const ASSISTANT_EMBED_URL =
  'https://easyai.passiolife.com/embed/chatbot?chatbotId=4de224d8-c8ae-456f-8bd8-37d350ee1504&apiKey=ZT3ift4W1-d7IoOz_x3MQMng6yZocy-2UAXaz62AtEY&customerTag=easyaitest';
